import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  getArtistsSelector,
  getCuratorsSelector,
  getUsersCount,
  getFoundUsers,
} from 'Redux/selectors/users'
import { signInAs } from 'Redux/actions/auth'
import {
  getArtists,
  getCurators,
  searchUsers,
  blockCurator,
  changeCuratorValidation,
} from 'Redux/actions/usersActions'
import {
  getTotalBalance,
  getPaidPayoutsList,
  getAwaitingPayoutsList,
  getPayoutsCounters,
} from 'Redux/selectors/payouts'
import {
  getAwaitingPayouts,
  getPaidPayouts,
  payoutToCurator,
  sendRecipientCheckingNeeded,
  getPayouts,
} from 'Redux/actions/payoutsActions'
import {
  getPlaylistsAdmin,
  getTotalPlaylistsCountAdmin,
  getFoundPlaylists,
} from 'Redux/selectors/playLists'
import {
  getPlaylistsListAdmin,
  searchPlaylists,
  getPlaylistInfo,
  setIsNewParameter,
  activatePlaylist,
  deactivatePlaylist,
} from 'Redux/actions/playListsActions'
import { getMonthlyListeners } from 'Redux/actions/adminAction'
import Component from './AdminPanel'

const selector = createStructuredSelector({
  artists: getArtistsSelector,
  curators: getCuratorsSelector,
  usersCount: getUsersCount,
  allFoundUsers: getFoundUsers,
  totalBalance: getTotalBalance,
  awaitingPayouts: getAwaitingPayoutsList,
  paidPayouts: getPaidPayoutsList,
  payoutCounters: getPayoutsCounters,
  playlists: getPlaylistsAdmin,
  totalPlaylists: getTotalPlaylistsCountAdmin,
  allFoundPlaylists: getFoundPlaylists,
})

const actions = {
  signInAs,
  getArtists,
  getCurators,
  searchUsers,
  getAwaitingPayouts,
  payoutToCurator,
  sendRecipientCheckingNeeded,
  blockCurator,
  getPaidPayouts,
  getPayouts,
  getPlaylistsListAdmin,
  searchPlaylists,
  getPlaylistInfo,
  setIsNewParameter,
  activatePlaylist,
  deactivatePlaylist,
  changeCuratorValidation,
  getMonthlyListeners,
}

export default connect(selector, actions)(Component)
